if (!window.__swiperLoaderInit) {
window.__swiperLoaderInit = true;

/**
 * Loads the Swiper vendor CSS and JS, then defines the swiper-slider custom element.
 * Safe to call multiple times — guards prevent duplicate asset injection.
 */
function loadSwiperAssets() {
  const loaderElement = document.querySelector("[data-swiper-script]");
  if (!loaderElement) return;

  const swiperCSSURL = loaderElement.dataset.swiperCss;
  if (swiperCSSURL && !document.querySelector(`link[href="${swiperCSSURL}"]`)) {
    const swiperCSS = document.createElement("link");
    swiperCSS.rel = "stylesheet";
    swiperCSS.href = swiperCSSURL;
    document.head.prepend(swiperCSS);
  }

  const swiperScriptURL = loaderElement.dataset.swiperScript;
  if (!swiperScriptURL) return;
  if (document.querySelector(`script[src="${swiperScriptURL}"]`)) return;

  const swiperScript = document.createElement("script");
  swiperScript.src = swiperScriptURL;
  swiperScript.async = true;
  swiperScript.onload = declareSwiperCustomElement;
  document.head.appendChild(swiperScript);
}

if (Shopify.designMode) {
  /** In the theme editor, always load Swiper so dynamically added sections work */
  loadSwiperAssets();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector("swiper-slider")) {
      loadSwiperAssets();
    }
  });
}

function declareSwiperCustomElement() {
  if (!!customElements.get("swiper-slider")) return;
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      this.isVideoWrapper = this.querySelector("[data-video-wrapper]");
      this.baseSliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.sliderOptions = null;
      this.activeIndex = 0;
      this.initialized = false;
      this.resizeBound = false;
      this.resizeTimeout = null;
      this.loopCapacityTimeout = null;
      this.loopCapacityInProgress = false;
      this.thumbsBaseOptions = null;
      this.loopFixAttached = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector("[data-swiper-thumbs]");
      }
      this.boundInitializeSwiper = this.initializeSwiper.bind(this);
      this.boundSlideToIndex = this.slideToIndex.bind(this);
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slides.length > 0) {
        this.initializeSwiper();
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }

    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "reinitialize":
          this.addEventListener("reinitialize-swiper", this.boundInitializeSwiper);
          break;
        case "slide-to-index":
          document.addEventListener("slide-to-index", this.boundSlideToIndex);
          break;
      }
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.boundHandleResize);
      clearTimeout(this.resizeTimeout);
      clearTimeout(this.loopCapacityTimeout);
      if (this.dataset.customEvent) {
        switch (this.dataset.customEvent) {
          case "reinitialize":
            this.removeEventListener("reinitialize-swiper", this.boundInitializeSwiper);
            break;
          case "slide-to-index":
            document.removeEventListener("slide-to-index", this.boundSlideToIndex);
            break;
        }
      }
    }

    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      if (options.speed === undefined) {
        options.speed = 400;
      }
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    resolveCssLengthValue(value) {
      if (typeof value === "number") return value;
      if (typeof value !== "string") return value;

      const trimmedValue = value.trim();

      if (/^-?\d+(\.\d+)?$/.test(trimmedValue)) {
        return Number(trimmedValue);
      }

      if (!trimmedValue.includes("var(") && !trimmedValue.includes("calc(") && !trimmedValue.endsWith("px")) {
        return value;
      }

      const measurementElement = document.createElement("div");
      measurementElement.style.position = "absolute";
      measurementElement.style.visibility = "hidden";
      measurementElement.style.pointerEvents = "none";
      measurementElement.style.inset = "0 auto auto 0";
      measurementElement.style.width = trimmedValue;
      this.appendChild(measurementElement);

      const resolvedValue = parseFloat(window.getComputedStyle(measurementElement).width);
      measurementElement.remove();

      return Number.isNaN(resolvedValue) ? value : resolvedValue;
    }

    resolveDynamicSliderOptions(options) {
      if (Array.isArray(options)) {
        return options.map((option) => this.resolveDynamicSliderOptions(option));
      }

      if (!options || typeof options !== "object") {
        return options;
      }

      return Object.entries(options).reduce((resolvedOptions, [key, value]) => {
        if (key === "slidesOffsetBefore" || key === "slidesOffsetAfter") {
          resolvedOptions[key] = this.resolveCssLengthValue(value);
        } else if (value && typeof value === "object") {
          resolvedOptions[key] = this.resolveDynamicSliderOptions(value);
        } else {
          resolvedOptions[key] = value;
        }

        return resolvedOptions;
      }, {});
    }

    updateDynamicSliderOptions() {
      if (!this.slider) return;

      const resolvedOptions = this.resolveDynamicSliderOptions(this.baseSliderOptions);
      this.sliderOptions = resolvedOptions;

      if (resolvedOptions.slidesOffsetBefore !== undefined) {
        this.slider.params.slidesOffsetBefore = resolvedOptions.slidesOffsetBefore;
        this.slider.originalParams.slidesOffsetBefore = resolvedOptions.slidesOffsetBefore;
      }

      if (resolvedOptions.slidesOffsetAfter !== undefined) {
        this.slider.params.slidesOffsetAfter = resolvedOptions.slidesOffsetAfter;
        this.slider.originalParams.slidesOffsetAfter = resolvedOptions.slidesOffsetAfter;
      }

      if (resolvedOptions.breakpoints && this.slider.params.breakpoints) {
        Object.keys(resolvedOptions.breakpoints).forEach((breakpoint) => {
          if (this.slider.params.breakpoints[breakpoint]) {
            Object.assign(this.slider.params.breakpoints[breakpoint], resolvedOptions.breakpoints[breakpoint]);
          }

          if (this.slider.originalParams.breakpoints?.[breakpoint]) {
            Object.assign(this.slider.originalParams.breakpoints[breakpoint], resolvedOptions.breakpoints[breakpoint]);
          }
        });
      }

      if (typeof this.slider.setBreakpoint === "function") {
        this.slider.setBreakpoint();
      }

      this.slider.update();
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        const swipperWrapper = this;
        this.sliderOptions = this.resolveDynamicSliderOptions(this.baseSliderOptions);
        const originalEvents = this.sliderOptions.on || {};
        if (this.thumbnails) {
          this.setThumbnails();
        }
        this.sliderOptions.on = {
          ...originalEvents,
          slideChange: function () {
            document.dispatchEvent(
              new CustomEvent("thumbnail-changed", {
                detail: {
                  slide: this.slides[this.activeIndex],
                },
              })
            );
            if (typeof originalEvents.slideChange === "function") {
              originalEvents.slideChange.apply(this, arguments);
            }
          },
          afterInit: function () {
            swipperWrapper.dispatchEvent(new CustomEvent("swiper:init", { bubbles: true }));
            if (typeof originalEvents.afterInit === "function") {
              originalEvents.afterInit.apply(this, arguments);
            }
            swipperWrapper.queueLoopCapacityCheck();
            if (this.thumbs) {
              swipperWrapper.dispatchEvent(
                new CustomEvent("swiper:thumbs-ready", {
                  bubbles: true,
                  detail: {
                    mainSlider: this,
                    thumbsSlider: this.thumbs?.swiper,
                    thumbsBaseOptions: swipperWrapper.thumbsBaseOptions,
                  },
                })
              );
            }
          },
        };
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);

        // Fix for loop + centeredSlides + auto slidesPerView:
        // Swiper may incorrectly set the active class on a duplicated slide.
        // Force slide to the correct initial position after initialization.
        if (this.sliderOptions.loop && this.sliderOptions.centeredSlides && this.sliderOptions.slidesPerView === "auto") {
          this.slider.slideToLoop(0, 0, false);
        }

        this.queueLoopCapacityCheck();
        // Run a second pass after initial paint so centered loop stabilizes without user interaction.
        if (this.sliderOptions.loop && this.sliderOptions.centeredSlides) {
          this.queueLoopCapacityCheck(80);
        }
        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
      this.bindResizeEvent();
    }

    bindResizeEvent() {
      if (!this.resizeBound) {
        window.addEventListener("resize", this.boundHandleResize);
        this.resizeBound = true;
      }
    }

    handleResize(e) {
      if (this.slider) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.updateDynamicSliderOptions();
          this.slider.updateSize();
          // Delay so layout and Swiper internals settle before re-evaluating loop/centerInsufficientSlides.
          this.queueLoopCapacityCheck(50);
        }, 300);
      }
    }

    queueLoopCapacityCheck(delay = 0) {
      clearTimeout(this.loopCapacityTimeout);
      this.loopCapacityTimeout = setTimeout(() => {
        this.ensureLoopCapacity();
      }, delay);
    }

    // Support loop-capacity source lookup for main and thumbs instances.
    getLoopCapacitySlides(targetSlider = this.slider) {
      if (!targetSlider?.wrapperEl) return [];
      return Array.from(targetSlider.wrapperEl.children).filter(
        (slide) =>
          slide.classList.contains("swiper-slide") && !slide.classList.contains("swiper-slide-duplicate")
      );
    }

    calculateSlidesTotalWidth(slides) {
      return slides.reduce((sum, slide) => {
        const rectWidth = slide.getBoundingClientRect().width;
        const style = window.getComputedStyle(slide);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        return sum + rectWidth + marginLeft + marginRight;
      }, 0);
    }

    /**
     * Attaches loopFix on slideChangeTransitionEnd to correct blank space at loop edges.
     * @param {Object} slider - Swiper instance
     * @param {string} attachedKey - Property key to track if already attached (e.g. 'loopFixAttached')
     */
    attachLoopFixListener(slider, attachedKey = "loopFixAttached") {
      if (this[attachedKey] || !slider?.params?.loop || !slider.params?.centeredSlides) return;
      this[attachedKey] = true;
      slider.on("slideChangeTransitionEnd", () => {
        if (slider.destroyed || !slider.params?.loop) return;
        if (typeof slider.loopFix === "function") {
          requestAnimationFrame(() => {
            if (slider.destroyed) return;
            slider.loopFix();
            slider.updateSlidesClasses?.();
          });
        }
      });
    }

    /**
     * Required width for loop: viewport + 1 slide.
     * Ensures enough content for seamless loop (slides that fit in view + 1).
     */
    getRequiredLoopWidth(containerWidth, slidesWidth, slideCount) {
      const widthPerSlide = slideCount > 0 ? slidesWidth / slideCount : 0;
      return containerWidth + widthPerSlide;
    }

    /**
     * Returns breakpoint-merged loop params for the current viewport width.
     * Uses window width to match Swiper's default breakpointsBase ('window').
     * Preserves user-configured per-breakpoint loop/centeredSlides on resize.
     */
    getBreakpointLoopParams(containerWidth) {
      const opts = this.sliderOptions || {};
      const breakpoints = opts.breakpoints || {};
      const breakpointWidth =
        opts.breakpointsBase === "container" ? containerWidth : (typeof window !== "undefined" ? window.innerWidth : containerWidth);
      const keys = Object.keys(breakpoints)
        .map(Number)
        .filter((k) => !Number.isNaN(k) && k <= breakpointWidth)
        .sort((a, b) => b - a);
      const active = keys[0] != null ? breakpoints[String(keys[0])] : {};
      return {
        loop: active.loop ?? opts.loop ?? false,
        centeredSlides: active.centeredSlides ?? opts.centeredSlides ?? false,
        centerInsufficientSlides: active.centerInsufficientSlides ?? opts.centerInsufficientSlides ?? false,
      };
    }

    /**
     * Swiper autoplay can remain paused after zero-duration slide/loop normalization calls.
     * Ensure configured autoplay resumes without requiring user interaction.
     */
    restoreAutoplayState() {
      if (!this.slider || this.slider.destroyed || !this.slider.params?.autoplay || !this.slider.autoplay) return;

      if (this.slider.autoplay.paused && typeof this.slider.autoplay.resume === "function") {
        this.slider.autoplay.resume();
        return;
      }

      if (!this.slider.autoplay.running && typeof this.slider.autoplay.start === "function") {
        this.slider.autoplay.start();
      }
    }

    /**
     * Fallback to centerInsufficientSlides when loop+centeredSlides are configured
     * but slides don't cover the viewport. Preserves breakpoint-intended params on restore.
     */
    ensureLoopCapacity() {
      this.applyLoopOrCenterInsufficientSlides(this.slider, (w) => this.getBreakpointLoopParams(w), {
        inProgressKey: "loopCapacityInProgress",
        loopFixAttachedKey: "loopFixAttached",
      });
    }

    /**
     * Applies loop or centerInsufficientSlides based on slide coverage.
     * Shared logic for main and thumbs sliders.
     * @param {Object} targetSlider - Swiper instance
     * @param {Object|Function} baseParamsOrGetter - { loop, centeredSlides, centerInsufficientSlides } or (containerWidth) => same
     * @param {Object} options - { inProgressKey, loopFixAttachedKey, modifyOriginalParams, onComplete }
     */
    applyLoopOrCenterInsufficientSlides(targetSlider, baseParamsOrGetter, options = {}) {
      const { inProgressKey, loopFixAttachedKey = "loopFixAttached", modifyOriginalParams = false, onComplete } = options;
      if (!targetSlider || targetSlider.destroyed || this[inProgressKey]) return;

      const containerWidth = targetSlider.width || targetSlider.el?.clientWidth || 0;
      if (!containerWidth) return;

      const baseParams =
        typeof baseParamsOrGetter === "function" ? baseParamsOrGetter(containerWidth) : baseParamsOrGetter;
      if (!baseParams?.loop || !baseParams?.centeredSlides) return;

      const sourceSlides = this.getLoopCapacitySlides(targetSlider);
      if (!sourceSlides.length) return;

      const slidesWidth = this.calculateSlidesTotalWidth(sourceSlides);
      const requiredWidth = this.getRequiredLoopWidth(containerWidth, slidesWidth, sourceSlides.length);
      const shouldUseCenterInsufficientSlides = slidesWidth < requiredWidth;
      const desiredLoop = shouldUseCenterInsufficientSlides ? false : baseParams.loop;
      const desiredCenteredSlides = shouldUseCenterInsufficientSlides ? false : baseParams.centeredSlides;
      const desiredCenterInsufficientSlides = shouldUseCenterInsufficientSlides
        ? true
        : baseParams.centerInsufficientSlides;

      const hasModeChanges =
        targetSlider.params.loop !== desiredLoop ||
        targetSlider.params.centeredSlides !== desiredCenteredSlides ||
        targetSlider.params.centerInsufficientSlides !== desiredCenterInsufficientSlides;
      if (!hasModeChanges) return;

      const activeRealIndex = targetSlider.realIndex ?? 0;
      this[inProgressKey] = true;

      try {
        if (targetSlider.params.loop && !desiredLoop && typeof targetSlider.loopDestroy === "function") {
          targetSlider.loopDestroy();
        }

        targetSlider.params.loop = desiredLoop;
        targetSlider.params.centeredSlides = desiredCenteredSlides;
        targetSlider.params.centerInsufficientSlides = desiredCenterInsufficientSlides;

        if (modifyOriginalParams && targetSlider.originalParams) {
          targetSlider.originalParams.loop = desiredLoop;
          targetSlider.originalParams.centeredSlides = desiredCenteredSlides;
          targetSlider.originalParams.centerInsufficientSlides = desiredCenterInsufficientSlides;
        }

        targetSlider.updateSlides();
        targetSlider.updateSize();
        if (desiredLoop) {
          targetSlider.params.loopedSlides = sourceSlides.length;
        }
        if (desiredLoop && typeof targetSlider.loopCreate === "function") {
          targetSlider.loopCreate();
        }
        targetSlider.update();
        targetSlider.updateSlidesClasses();

        if (typeof targetSlider.slideToLoop === "function") {
          targetSlider.slideToLoop(activeRealIndex, 0, false);
        } else if (typeof targetSlider.slideTo === "function") {
          targetSlider.slideTo(activeRealIndex, 0, false);
        }

        if (desiredLoop) {
          this.attachLoopFixListener(targetSlider, loopFixAttachedKey);
        }
        if (typeof onComplete === "function") onComplete();
        this.restoreAutoplayState();
      } finally {
        this[inProgressKey] = false;
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.thumbsBaseOptions = {
        loop: !!thumbnailsSlider.params.loop,
        centeredSlides: !!thumbnailsSlider.params.centeredSlides,
        centerInsufficientSlides: !!thumbnailsSlider.params.centerInsufficientSlides,
      };
      this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
    }

    initializeSliderEventListeners() {
      if (this.isVideoWrapper) {
        this.slider.on("slideChange", () => {
          const activeIndex = this.slider.realIndex !== undefined ? this.slider.realIndex : this.slider.activeIndex;
          this.slides.forEach((slide, index) => {
            if (index === activeIndex || !slide.dataset?.videoWrapper) {
              return;
            }
            const deferredMediaElements = slide.querySelectorAll("deferred-media");
            deferredMediaElements.forEach((deferredMedia) => {
              if (!deferredMedia.hasAttribute("autoplay") && typeof deferredMedia.pauseMedia === "function") {
                deferredMedia.pauseMedia();
              }
            });
          });
        });
      }
    }

    /**
     * Slides to a specific index when receiving a document event
     * @param {CustomEvent} event - The custom event containing slide index details
     */
    slideToIndex(event) {
      if (!this.slider || !this.initialized) {
        console.warn("SwiperSlider - Slider not initialized");
        return;
      }

      const { index, speed, sliderId } = event.detail || {};

      // If sliderId is specified, only respond to events meant for this slider
      if (sliderId && this.dataset.sliderId !== sliderId) {
        return;
      }

      if (typeof index === "number" && index >= 0 && index <= this.slides.length) {
        let slidesIndex = undefined;
        for (let i = 0; i < this.slider.slides.length; i++) {
          if (parseInt(this.slider.slides[i].dataset.actualSlideIndex) === index) {
            slidesIndex = i;
          }
        }
        const slideSpeed = speed !== undefined ? speed : this.sliderOptions.speed;
        this.slider.slideTo(slidesIndex || index, slideSpeed);
      } else {
        console.warn("SwiperSlider - Invalid slide index:", index);
      }
    }
  }
  customElements.define("swiper-slider", SwiperSlider);
}
}
